/**
 * @file 错误提示组件
 * @author FranckChen(chenfan02@baidu.com)
 */

import React from 'react';

const ErrorInfo = function () {
    return (
        <div className="ai-np-error">
            预览解析出错
        </div>
    );
};

export default ErrorInfo;
